module.exports = __webpack_public_path__ + "static/media/20220801_174804.f08c8c3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/20220801_174804.mp3
// module id = pawG
// module chunks = 1